// extracted by mini-css-extract-plugin
export var noSpinners = "_sv-6";
export var percentageInput = "_sv-7";
export var variantColor1 = "_sv-0";
export var variantColor2 = "_sv-1";
export var variantColor3 = "_sv-2";
export var variantColor4 = "_sv-3";
export var variantColor5 = "_sv-4";
export var variantColor6 = "_sv-5";